export const GooglePlayIcon = () => {
  return (
    <svg
      width="27"
      height="30"
      viewBox="0 0 27 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_ii_3145_23294)">
        <path
          d="M1.47952 1.29319C1.15942 1.63199 0.970214 2.15779 0.970214 2.83869V27.1663C0.970214 27.8483 1.15942 28.373 1.47952 28.7118L1.56092 28.791L15.1888 15.1631V15.0025V14.8419L1.56092 1.21289L1.47952 1.29319Z"
          fill="url(#paint0_linear_3145_23294)"
        />
        <path
          d="M19.7309 19.7071L15.189 15.163V15.0024V14.8418L19.732 10.2988L19.8343 10.3571L25.2166 13.4151C26.7533 14.2885 26.7533 15.7174 25.2166 16.5919L19.8343 19.6499L19.7309 19.7071Z"
          fill="url(#paint1_linear_3145_23294)"
        />
        <g filter="url(#filter1_i_3145_23294)">
          <path
            d="M19.8341 19.6484L15.1877 15.002L1.47949 28.7113C1.98549 29.2481 2.82259 29.3141 3.76529 28.7795L19.8341 19.6484Z"
            fill="url(#paint2_linear_3145_23294)"
          />
        </g>
        <path
          d="M19.8341 10.3552L3.76529 1.22515C2.82259 0.689451 1.98549 0.756552 1.47949 1.29335L15.1888 15.0027L19.8341 10.3552Z"
          fill="url(#paint3_linear_3145_23294)"
        />
      </g>
      <defs>
        <filter
          id="filter0_ii_3145_23294"
          x="0.970215"
          y="0.855469"
          width="25.3989"
          height="28.293"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3145_23294"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_innerShadow_3145_23294"
            result="effect2_innerShadow_3145_23294"
          />
        </filter>
        <filter
          id="filter1_i_3145_23294"
          x="1.47949"
          y="15.002"
          width="18.3545"
          height="14.1465"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-0.15" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_3145_23294"
          />
        </filter>
        <linearGradient
          id="paint0_linear_3145_23294"
          x1="13.9808"
          y1="2.58129"
          x2="-4.4794"
          y2="21.0415"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00A0FF" />
          <stop offset="0.0066" stop-color="#00A1FF" />
          <stop offset="0.2601" stop-color="#00BEFF" />
          <stop offset="0.5122" stop-color="#00D2FF" />
          <stop offset="0.7604" stop-color="#00DFFF" />
          <stop offset="1" stop-color="#00E3FF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_3145_23294"
          x1="27.2169"
          y1="15.0024"
          x2="0.601426"
          y2="15.0024"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE000" />
          <stop offset="0.4087" stop-color="#FFBD00" />
          <stop offset="0.7754" stop-color="#FFA500" />
          <stop offset="1" stop-color="#FF9C00" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_3145_23294"
          x1="17.3108"
          y1="17.5252"
          x2="-7.72354"
          y2="42.5596"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FF3A44" />
          <stop offset="1" stop-color="#C31162" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_3145_23294"
          x1="-1.97297"
          y1="-6.80507"
          x2="9.20556"
          y2="4.37346"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#32A071" />
          <stop offset="0.0685" stop-color="#2DA771" />
          <stop offset="0.4762" stop-color="#15CF74" />
          <stop offset="0.8009" stop-color="#06E775" />
          <stop offset="1" stop-color="#00F076" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const Apple = () => {
  return (
    <svg
      width="20"
      height="25"
      viewBox="0 0 20 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7458 13.3302C16.7696 11.4811 17.7627 9.73144 19.338 8.76293C18.3442 7.34357 16.6796 6.44366 14.9477 6.38948C13.1006 6.19559 11.3098 7.49479 10.3685 7.49479C9.40905 7.49479 7.9598 6.40873 6.39919 6.44084C4.36502 6.50656 2.46865 7.66308 1.47898 9.44149C-0.648418 13.1248 0.93843 18.5379 2.9763 21.5152C3.99589 22.9731 5.1875 24.6016 6.7467 24.5438C8.27246 24.4805 8.84231 23.5709 10.684 23.5709C12.5087 23.5709 13.0433 24.5438 14.6341 24.5071C16.2714 24.4805 17.3029 23.0427 18.2867 21.571C19.0193 20.5322 19.583 19.3841 19.957 18.1693C18.0329 17.3555 16.748 15.4192 16.7458 13.3302Z"
        fill="white"
      />
      <path
        d="M13.741 4.43148C14.6336 3.35985 15.0734 1.98245 14.9669 0.591797C13.6031 0.735039 12.3433 1.38685 11.4386 2.41737C10.5539 3.42423 10.0935 4.77739 10.1805 6.1149C11.5448 6.12894 12.886 5.4948 13.741 4.43148Z"
        fill="white"
      />
    </svg>
  );
};

export const Visa = () => {
  return (
    <svg
      width="35"
      height="24"
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" stroke="#F2F4F7" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.0667 15.8579H8.94634L7.35636 9.79198C7.28089 9.51295 7.12065 9.26627 6.88495 9.15001C6.29672 8.85784 5.64852 8.62531 4.94141 8.50804V8.2745H8.35708C8.82849 8.2745 9.18205 8.62531 9.24098 9.03274L10.0659 13.4083L12.1852 8.2745H14.2466L11.0667 15.8579ZM15.4252 15.8579H13.4227L15.0716 8.2745H17.0741L15.4252 15.8579ZM19.6648 10.3753C19.7237 9.96689 20.0773 9.73335 20.4897 9.73335C21.1379 9.67471 21.844 9.79199 22.4333 10.0832L22.7868 8.45042C22.1976 8.21688 21.5494 8.09961 20.9612 8.09961C19.0176 8.09961 17.6034 9.15002 17.6034 10.6078C17.6034 11.7169 18.6051 12.2992 19.3123 12.65C20.0773 12.9998 20.3719 13.2334 20.313 13.5832C20.313 14.1079 19.7237 14.3414 19.1355 14.3414C18.4284 14.3414 17.7212 14.1665 17.0741 13.8743L16.7205 15.5081C17.4276 15.7992 18.1926 15.9165 18.8998 15.9165C21.079 15.9741 22.4333 14.9247 22.4333 13.3496C22.4333 11.3661 19.6648 11.2498 19.6648 10.3753ZM29.4414 15.8579L27.8514 8.2745H26.1436C25.79 8.2745 25.4365 8.50804 25.3186 8.85784L22.3744 15.8579H24.4358L24.8472 14.7498H27.38L27.6157 15.8579H29.4414ZM26.4382 10.3167L27.0265 13.1747H25.3775L26.4382 10.3167Z"
        fill="#172B85"
      />
    </svg>
  );
};

export const MasterCard = () => {
  return (
    <svg
      width="35"
      height="24"
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" fill="white" />
      <rect x="0.5" y="0.5" width="34" height="23" rx="3.5" stroke="#F2F4F7" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.684 16.8288C16.4652 17.8268 14.8841 18.4293 13.1564 18.4293C9.30138 18.4293 6.17627 15.4296 6.17627 11.7293C6.17627 8.02899 9.30138 5.0293 13.1564 5.0293C14.8841 5.0293 16.4652 5.63179 17.684 6.62984C18.9029 5.63179 20.484 5.0293 22.2117 5.0293C26.0667 5.0293 29.1918 8.02899 29.1918 11.7293C29.1918 15.4296 26.0667 18.4293 22.2117 18.4293C20.484 18.4293 18.9029 17.8268 17.684 16.8288Z"
        fill="#ED0006"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.6841 16.8288C19.1849 15.5999 20.1366 13.7713 20.1366 11.7293C20.1366 9.68734 19.1849 7.85874 17.6841 6.62983C18.903 5.63179 20.484 5.0293 22.2117 5.0293C26.0667 5.0293 29.1918 8.02899 29.1918 11.7293C29.1918 15.4296 26.0667 18.4293 22.2117 18.4293C20.484 18.4293 18.903 17.8268 17.6841 16.8288Z"
        fill="#F9A000"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.6839 16.8278C19.1847 15.5989 20.1363 13.7703 20.1363 11.7283C20.1363 9.6864 19.1847 7.85781 17.6839 6.62891C16.1831 7.85781 15.2314 9.6864 15.2314 11.7283C15.2314 13.7703 16.1831 15.5989 17.6839 16.8278Z"
        fill="#FF5E00"
      />
    </svg>
  );
};

export const ForwardIcon = () => {
  return (
    <svg
      width="6"
      height="10"
      viewBox="0 0 6 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1 9L5 5L1 1"
        stroke="#475467"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Delete = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3333 5.0013V4.33464C13.3333 3.40121 13.3333 2.9345 13.1517 2.57798C12.9919 2.26438 12.7369 2.00941 12.4233 1.84962C12.0668 1.66797 11.6001 1.66797 10.6667 1.66797H9.33333C8.39991 1.66797 7.9332 1.66797 7.57668 1.84962C7.26308 2.00941 7.00811 2.26438 6.84832 2.57798C6.66667 2.9345 6.66667 3.40121 6.66667 4.33464V5.0013M2.5 5.0013H17.5M15.8333 5.0013V14.3346C15.8333 15.7348 15.8333 16.4348 15.5608 16.9696C15.3212 17.44 14.9387 17.8225 14.4683 18.0622C13.9335 18.3346 13.2335 18.3346 11.8333 18.3346H8.16667C6.76654 18.3346 6.06647 18.3346 5.53169 18.0622C5.06129 17.8225 4.67883 17.44 4.43915 16.9696C4.16667 16.4348 4.16667 15.7348 4.16667 14.3346V5.0013"
        stroke="#475467"
        stroke-width="1.6"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
